import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable, catchError, debounceTime, map, of, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectMunicipioService {
  constructor(private _httpClient: HttpClient) {}

  //  ONDE
  //   constructor(this._municipios : SelectMunicipioService)
  //
  // ngAfterViewInit(): void {
  //   this._municipios
  //     .completeMunicipio(this.controlMunicipio.valueChanges)
  //     .subscribe((resp) => {
  //       if (resp?.length) {
  //         this.municipios = resp?.slice(0, 20);
  //
  //         this._changeDetectorRef.markForCheck();
  //       }
  //     });
  // }

  // ===================== ACIMA EXEMPLO DE IMPLEMENTAÇÃO ================

  ultimo = '';
  completeMunicipio(input: Observable<String>): Observable<any> {
    return input.pipe(
      debounceTime(600),
      map((value) => {
        if (typeof value === 'string' && !value.includes(' - ')) {
          return value;
        } else {
          return '';
        }
      }),
      switchMap((texto: any) => {
        if (typeof texto === 'string') {
          if (texto && this.ultimo !== texto?.trim() && texto?.length > 3) {
            this.ultimo = texto?.trim();
            return this.municipios(texto).pipe(take(1));
          } else {
            this.ultimo = texto?.trim();

            return of([]);
          }
        }
      }),
      catchError(() => of(false))
    );
  }

  municipios(text: any) {
    return this._httpClient.post(`${environment.api}/municipio/complete`, text);
  }
}
